<template>
    <div class="timeline-year-panel">
        <h3 class="timeline-year-panel__title">{{title}}</h3>
        <div class="timeline-year-panel__content">
            <template v-for="item in child">
                <timeline-mouth :key="item.title" :data="item"/>
            </template>
        </div>
    </div>
</template>

<script>
    import TimelineMouth from '@components/TimelineMouth'

    export default {
        name: "TimelineYear",
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        computed: {
            title() {
                const {data} = this
                return data.title || ''
            },
            child() {
                const {data} = this
                return data.child || []
            }
        },
        components: {
            TimelineMouth
        }
    }
</script>

<style lang="scss">
    @import '@assets/styles/varibles.scss';

    .timeline-year-panel {
        margin-bottom: $paddingSP;

        &__title {
            margin-bottom: $paddingMD;
            font-size: $fontSizeMD;
            font-weight: $fontWeightBold;
            color: $textColor;
            color: var(--textColor);
        }
    }
</style>